"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDecimalPlaces = exports.fileSizeToMb = exports.nFormatter = exports.isValidNumber = void 0;
exports.fNumber = fNumber;
exports.fCurrency = fCurrency;
exports.fPercent = fPercent;
exports.fShortenNumber = fShortenNumber;
exports.fData = fData;
var numeral_1 = __importDefault(require("numeral"));
// ----------------------------------------------------------------------
var isValidNumber = function (value) {
    return typeof value === "number" && !isNaN(value) && isFinite(value);
};
exports.isValidNumber = isValidNumber;
function fNumber(number) {
    return (0, numeral_1.default)(number).format();
}
function fCurrency(number) {
    var format = number ? (0, numeral_1.default)(number).format("$0,0.00") : "";
    return result(format, ".00");
}
function fPercent(number) {
    var format = number ? (0, numeral_1.default)(Number(number) / 100).format("0.0%") : "";
    return result(format, ".0");
}
function fShortenNumber(number) {
    var format = number ? (0, numeral_1.default)(number).format("0.00a") : "";
    return result(format, ".00");
}
function fData(number) {
    var format = number ? (0, numeral_1.default)(number).format("0.0 b") : "";
    return result(format, ".0");
}
function result(format, key) {
    if (key === void 0) { key = ".00"; }
    var isInteger = format.includes(key);
    return isInteger ? format.replace(key, "") : format;
}
var nFormatter = function (num, digits) {
    var lookup = [
        { symbol: "", value: 1 },
        { symbol: "k", value: 1e3 },
        { symbol: "M", value: 1e6 },
        { symbol: "G", value: 1e9 },
        { symbol: "T", value: 1e12 },
        { symbol: "P", value: 1e15 },
        { symbol: "E", value: 1e18 },
    ];
    var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
        .slice()
        .reverse()
        .find(function (item) {
        return num >= item.value;
    });
    return item
        ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
        : "0";
};
exports.nFormatter = nFormatter;
var fileSizeToMb = function (sizeInBytes) {
    return "".concat((sizeInBytes / (1024 * 1024)).toFixed(2), "Mb");
};
exports.fileSizeToMb = fileSizeToMb;
var formatDecimalPlaces = function (value, minimumFractionDigits) {
    if (minimumFractionDigits === void 0) { minimumFractionDigits = 2; }
    return value.toLocaleString(undefined, {
        maximumFractionDigits: minimumFractionDigits !== null && minimumFractionDigits !== void 0 ? minimumFractionDigits : 2,
        minimumFractionDigits: minimumFractionDigits,
        style: "decimal",
        useGrouping: true,
    });
};
exports.formatDecimalPlaces = formatDecimalPlaces;
